// extracted by mini-css-extract-plugin
export var currencyInput = "_m2-1";
export var currencySymbol = "_m2-0";